
import { components } from '~/slices'

import prismicCustomTypePageContent from '~/mixins/prismicCustomType/single'
import headData from '~/mixins/headData'
import {
  DEPARTMENTS_URL,
  getCleanDepartments,
  isPromotedJob,
  getFilteredJobs,
  getJobsLocationList,
} from '@/utils/jobs'

const type = 'vacancies'

export default {
  name: 'Vacancies',
  mixins: [prismicCustomTypePageContent({ type }), headData],
  data() {
    return {
      isLoading: true,
      error: false,
      jobs: [],
      departments: [],
      paginationStep: 8,
      components,
    }
  },
  async fetch() {
    try {
      const departments = await this.getAllDepartments()

      this.departments = getCleanDepartments(departments)
    } catch (err) {
      this.error = true
    } finally {
      this.isLoading = false
    }
  },
  fetchOnServer: false,
  computed: {
    filters() {
      return {
        jobCategory: this.$route.query.jobCategory,
        subCategories:
          typeof this.$route.query.subCategories === 'string'
            ? [this.$route.query.subCategories]
            : this.$route.query.subCategories,
        jobLocation: this.$route.query.jobLocation,
        page: Number(this.$route.query.page) || 0,
      }
    },
    allFilteredResults() {
      return getFilteredJobs(this.departments, this.filters)
    },
    promotedJob() {
      return this.allFilteredResults.find(isPromotedJob)
    },
    isPromotedJobVisible() {
      return this.promotedJob && this.filters.page === 0
    },
    filteredJobs() {
      if (this.promotedJob) {
        return this.allFilteredResults.filter(
          ({ id }) => id !== this.promotedJob.id
        )
      }

      return this.allFilteredResults
    },
    currentPageJobs() {
      const pageStartIndex = this.filters.page * this.paginationStep
      const pageEndIndex = pageStartIndex + this.paginationStep
      return this.filteredJobs.slice(pageStartIndex, pageEndIndex)
    },
    locations() {
      return getJobsLocationList(this.allFilteredResults)
    },
    categories() {
      return this.departments.map(({ name }) => name)
    },
    childCategories() {
      const currentCategory = this.departments.find(
        ({ name }) => this.filters.jobCategory === name
      )

      return currentCategory
        ? currentCategory.children.map(({ name }) => name)
        : []
    },
  },
  methods: {
    async getAllDepartments() {
      return await this.$axios
        .$get(DEPARTMENTS_URL)
        .then(({ departments }) => departments)
    },
    filterChangeHandler(filterName, value) {
      // if there is a falsy value (0, ""), hide the query param from the url
      const paramValue = value || undefined
      let filters = {
        [filterName]: paramValue,
      }

      if (filterName === 'jobCategory') {
        filters = {
          [filterName]: paramValue,
          subCategories: [],
        }
      }

      this.$router.push({
        query: {
          ...this.$route.query,
          // reset pagination on each filter change
          page: undefined,
          ...filters,
        },
      })
    },
  },
}
